// frontend/src/lib/iban.ts

// Simple helpers (not a full validator): normalize + length hints
const IBAN_LENGTHS: Record<string, number> = {
  DE: 22, SE: 24, GB: 22, FR: 27, ES: 24, IT: 27, NL: 18, BE: 16, DK: 18, NO: 15,
  FI: 18, AT: 20, PT: 25, IE: 22, PL: 28, RO: 24, GR: 27, CZ: 24, SK: 24, SI: 19,
  EE: 20, LT: 20, LV: 21, LU: 20, HU: 28, HR: 21, BG: 22, CY: 28, MT: 31
};

export function normalizeIban(input: string) {
  return input.replace(/\s+/g, '').toUpperCase();
}

export function prettyIban(input: string) {
  return normalizeIban(input).replace(/(.{4})/g, '$1 ').trim();
}

export function ibanHint(country: string) {
  const cc = country.trim().toUpperCase();
  const len = IBAN_LENGTHS[cc];
  if (!len) return 'IBAN length varies by country';
  return `${cc} IBAN should be ${len} characters`;
}

// --- NEW: remote validator used by RecipientCreate.tsx ---
export type IbanValidationResponse = {
  valid: boolean;
  iban?: string | null;
  country?: string | null;
  bank?: string | null;
  currency?: string | null;
  message?: string; // present on length/prefix fallback errors
};

export async function validateIbanRemote(iban: string): Promise<IbanValidationResponse> {
  const q = normalizeIban(iban);
  const res = await fetch(`/api/iban/validate?iban=${encodeURIComponent(q)}`, {
    method: 'GET',
    credentials: 'include',
    headers: { 'Accept': 'application/json' },
  });
  if (!res.ok) {
    // Keep it simple; surfaces network/API issues to the UI
    throw new Error(`IBAN validation failed (${res.status})`);
  }
  return res.json() as Promise<IbanValidationResponse>;
}
